module.exports = __webpack_public_path__ + "img/quad-temperature-md.a735e41f.svg";